<div class="form tpl-form-2">

    <form action="" lmoid="0">

        <p>&nbsp;</p>

        <div class="row d-flex justify-content-center">
            <div class="col-xl-4 col-md-6">
                <div class="line">
                    <div class="card-file active tappable" (click)="balanceInput.click()">
                        <a href="javascript:;" class="click-info" data-info-id="info-1"><i class="info">i</i></a>
                        <div class="icon-file">
                            <input (change)="uploadBalanceFile(companyId, $event)" #balanceInput style="display: none;"
                                type="file">
                        </div>
                        <div class="label-file">
                            Balanço/DRE/Faturamento
                            <span class="text-danger"> *</span>
                        </div>
                        <br>
                        <p><b>Atual: </b>{{ corporateAccount.balanceDRERevenue }}</p>
                        <p *ngIf="balanceInput.files[0]?.name"><b>Novo: </b>{{ balanceInput.files[0].name }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row d-flex justify-content-center">
            <div class="col-xl-4 col-md-6">
                <div class="line">
                    <div class="card-file active tappable" (click)="residentialProofInput.click()">
                        <a href="javascript:;" class="click-info" data-info-id="info-2"><i class="info">i</i></a>
                        <div class="icon-file">
                            <input (change)="uploadResidenceFile(companyId, $event)" #residentialProofInput
                                style="display: none;" type="file">
                        </div>
                        <div class="label-file">
                            Comprovante de residência
                            <span class="text-danger"> *</span>
                        </div>
                        <br>
                        <p><b>Atual: </b>{{ corporateAccount.residentialProof }}</p>

                        <p *ngIf="residentialProofInput.files[0]?.name"><b>Novo:
                            </b>{{ residentialProofInput.files[0].name }}</p>

                    </div>
                </div>
            </div>
        </div>


        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>


        <div class="cadastro-line-btn">
            <div class="form-row">
                <div class="cols">
                    <div class="form-group">
                        <button type="button" (click)="openCancelModal()" class="btn-xp-m2 btn-blue-30-b">
                            Cancelar
                        </button>
                    </div>
                </div>
                <div class="cols">
                    <div class="form-group">
                        <button (click)="goPrevious()" type="button" class="btn-xp-m2 btn-blue-30-b">Voltar</button>
                    </div>
                </div>
                <div class="cols">
                    <div class="form-group mb-0">
                        <button *ngIf="balanceSent && residenceSent" (click)="goNext()" type="button"
                            class="btn-xp-m2 btn-blue-30">
                            Avançar
                            <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
                        </button>
                        <button [disabled]="loading"
                            *ngIf="balanceSent && !residenceSent || !balanceSent && residenceSent" type="button"
                            class="btn-xp-m2 btn-gray-disabled" disabled>
                            Avançar
                            <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </form>

</div>
